import React, { Component } from 'react';

// Componente nuevo: sección "Labor como Regidora"
// Fuente: documento oficial del cliente

class LaborRegidora extends Component {
    constructor(props){
        super(props);
        this.state = {
            bloques: [
                {
                    id: 1,
                    icono: 'bi bi-search',
                    titulo: 'Fiscalización de los Recursos Públicos',
                    items: [
                        { fuerte: 'Análisis de ingresos y egresos', detalle: 'Revisión permanente de los informes mensuales para verificar la correcta aplicación de los recursos.' },
                        { fuerte: 'Cuestionamiento de subejercicios', detalle: 'Señalamiento de subejercicios presupuestales y reasignaciones de recursos.' },
                        { fuerte: 'Transparencia del gasto', detalle: 'Solicitud del destino y aplicación de las distintas partidas presupuestales.' },
                        { fuerte: 'Uso eficiente de excedentes', detalle: 'Vigilancia del ejercicio de los excedentes financieros del municipio.' },
                        { fuerte: 'Control de la nómina', detalle: 'Claridad sobre la plantilla laboral y el impacto de nuevas contrataciones.' }
                    ]
                },
                {
                    id: 2,
                    icono: 'bi bi-shield-check',
                    titulo: 'Vigilancia del Buen Funcionamiento de la Administración',
                    items: [
                        { fuerte: 'Transparencia gubernamental', detalle: 'Propuesta de modificación al artículo 127 del Reglamento Interior del Ayuntamiento.' },
                        { fuerte: 'Servicios públicos esenciales', detalle: 'Priorización de alumbrado, bacheo, mantenimiento y programas de atención social.' },
                        { fuerte: 'Apoyo integral a las mujeres', detalle: 'Fortalecimiento de la atención del Instituto Municipal de la Mujer.' },
                        { fuerte: 'Participación en el Cabildo', detalle: 'Trabajo activo en sesiones y comisiones permanentes.' },
                        { fuerte: 'Voto responsable y razonado', detalle: 'Decisiones en favor del interés público y las familias del municipio.' }
                    ]
                }
            ]
        }
    }

    render() {
        return (
            <section className="section-padding bg-grey" id="labor">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="section-heading center-heading text-center mb-60">
                                <span className="subheading">Mi labor como Regidora</span>
                                <h3 className="heading-title">Acciones concretas en el Cabildo de Mineral de la Reforma</h3>
                                <p>Cada acción está documentada en las actas de sesión del Ayuntamiento.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {
                            this.state.bloques.map((bloque) => (
                                <div className="col-lg-6 col-md-12" key={bloque.id}>
                                    <div className="about-text-block">
                                        <i className={bloque.icono}></i>
                                        <h4>{bloque.titulo}</h4>
                                        <ul className="list-unstyled mt-3 labor-list">
                                            {
                                                bloque.items.map((item, i) => (
                                                    <li key={i} className="labor-item">
                                                        <i className="fa fa-check text-mp-gold"></i>
                                                        <span><strong>{item.fuerte}.</strong> {item.detalle}</span>
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </section>
        );
    }
}

export default LaborRegidora;
